import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Pagination } from "../../../Utils";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Helmet } from "react-helmet-async";
import {
  Confirmation,
  ErrorToast,
  SuccessToast,
} from "../../../Utils/SweetAlert";
import {
  BlockCustomer,
  GetExpiredDocumentUserPaginate,
} from "../../../Services/Api/customer";
import format from "date-fns/format";
import { showCustName } from "../../../Utils/CommanFunctions";

const ExpiredDocumentUsers = () => {
  const history = useNavigate();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [ExpiredDocumentUserList, setExpiredDocumentUserList] = useState([]);

  const getExpiredDocumentUser = async (limitO = "", pageO = "") => {
    setIsLoading(true);
    await GetExpiredDocumentUserPaginate({ limit: limitO, page: pageO })
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.data?.totalRecords > 0) {
          setExpiredDocumentUserList(res?.data?.data?.customers);
          setTotalRecords(res?.data?.data?.totalRecords);
        } else {
          setExpiredDocumentUserList([]);
          setTotalRecords(0);
          // ErrorToast("No Results.");
        }
      })
      .catch((err) => {
        setExpiredDocumentUserList([]);
        setTotalRecords(0);
        setIsLoading(false);
        // if (typeof err.response.data.message !== "undefined") {
        //   ErrorToast(err.response.data.message || "Server Error!!");
        // } else {
        //   ErrorToast(err?.message || "Server Error!!");
        // }
      });
  };
  const handlePageChange = async (e, pageNew) => {
    setPage(pageNew);
    await getExpiredDocumentUser(limit, pageNew);
  };
  const handleLimitChange = async (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
    await getExpiredDocumentUser(parseInt(event.target.value, 10), 0);
  };

  const changeBlock = (customer, text) => {
    Confirmation(text).then(async (result) => {
      if (result.isConfirmed) {
        const postObj = {
          customer_id: customer._id,
          is_blocked: `${customer.is_blocked ^ 1}`,
        };
        await BlockCustomer(postObj)
          .then((res) => {
            SuccessToast(res?.data.message || "Status Updated");
            getExpiredDocumentUser(limit, page);
          })
          .catch((err) => {
            // if (typeof err.response.data.message !== "undefined") {
            //   ErrorToast(err.response.data.message || "Server Error!!");
            // } else {
            //   ErrorToast(err?.message || "Server Error!!");
            // }
          });
      }
    });
  };

  useEffect(() => {
    getExpiredDocumentUser(limit, page);
  }, [limit, page]);

  return (
    <>
      <Helmet>
        <title>CPay | Admin Expired Document Users</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Expired Document Users</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/admin/customer">Customers</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    Expired Document Users
                  </li>
                </ul>
              </div>
              <div className="col-auto">
                <Link to="/admin/customer" className="btn btn-primary me-1">
                  <i className="fas fa-angle-double-left" /> Back
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-center table-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th>#</th>
                          <th>Customer</th>
                          <th>Email</th>
                          <th>Total Balance</th>
                          <th>Registered On</th>
                          <th>Block</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isLoading && (
                          <>
                            {ExpiredDocumentUserList.map((customer, index) => (
                              <tr key={index}>
                                <td>{limit * page + (index + 1)}</td>
                                <td>
                                  <h2 className="table-avatar">
                                    {/* <Link to="/admin/customer-profile" className="avatar avatar-sm me-2"><img className="avatar-img rounded-circle" src="../inner-assets/img/profiles/avatar-02.jpg" alt="User" /></Link>
                            <Link to="/admin/customer-profile">{customer.name} <span>{customer.phone}</span></Link> */}
                                    <Link
                                      to="/admin/customer"
                                      className="avatar avatar-sm me-2"
                                    >
                                      <img
                                        className="avatar-img rounded-circle"
                                        src={
                                          customer.profile_picture ||
                                          "../inner-assets/img/profiles/default_image.jpg"
                                        }
                                        alt="User"
                                      />
                                    </Link>

                                    <Link to="/admin/customer">
                                      {showCustName(customer.name, customer.company_name)}{" "}
                                      <span>{customer.phone}</span>
                                    </Link>
                                  </h2>
                                </td>
                                <td>{customer.email}</td>
                                <td>
                                  <a
                                    className="invoice-link"
                                    onClick={() =>
                                      history("/admin/customer-statement", {
                                        state: {
                                          id: customer?.wallet?.user_id,
                                        },
                                      })
                                    }
                                  >
                                    <span className="currency-type-text">
                                      {customer?.wallet?.currency}
                                    </span>{" "}
                                    {customer?.wallet?.total_amount || "0"}
                                  </a>
                                </td>
                                <td>
                                  {format(
                                    new Date(customer.createdAt),
                                    "dd MMMM, yyyy"
                                  )}
                                </td>
                                <td>
                                  {customer.is_blocked === 1 && (
                                    <button
                                      className="btn btn-sm  btn-block btn-outline-danger"
                                      onClick={() => {
                                        changeBlock(
                                          customer,
                                          "Want to active customer?"
                                        );
                                      }}
                                    >
                                      Suspend
                                    </button>
                                  )}
                                  {customer.is_blocked === 0 && (
                                    <button
                                      className="btn btn-sm  btn-block btn-outline-secondary"
                                      onClick={() => {
                                        changeBlock(
                                          customer,
                                          "Want to suspend customer?"
                                        );
                                      }}
                                    >
                                      Active
                                    </button>
                                  )}
                                </td>
                                <td className="text-end">
                                  <Tooltip
                                    title="view document"
                                    className="btn btn-sm btn-white text-warning me-2"
                                    onClick={() =>
                                      history("/admin/customer-legaldocument", {
                                        state: { id: customer._id },
                                      })
                                    }
                                  >
                                    <IconButton>
                                      <InsertDriveFileIcon />
                                    </IconButton>
                                  </Tooltip>
                                </td>
                              </tr>
                            ))}
                            {ExpiredDocumentUserList.length === 0 && (
                              <tr>
                                <td colSpan={7}>No Records Found.</td>
                              </tr>
                            )}
                          </>
                        )}
                        {isLoading && (
                          <tr>
                            <td align="center" colSpan={7}>
                              Loading...
                            </td>
                          </tr>
                        )}
                        <Pagination
                          totalItem={totalRecords}
                          itemsPerPage={limit}
                          page={page}
                          handleChangePage={handlePageChange}
                          handleChangeRowsPerPage={handleLimitChange}
                          colSpan={7}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="content container-fluid absolute px-2">
              <footer className="text-center text-lg-start">
                <div className="text-center pb-4">
                  Powered by Alsaffron System.
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpiredDocumentUsers;
